import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../../environments/environment';
import { FinancialCompany } from '../../models/finance/financial-company';

@Injectable({ providedIn: 'root' })
export class FinancialCompanyProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/financial-companies';

  /** Resolves the FinancialCompany that owns a site. */
  public getBySite(siteReference: string): Observable<ApiResponse<FinancialCompany>> {
    return this.httpClient.get<ApiResponse<FinancialCompany>>(`${this.baseUrl}/by-site/${siteReference}`);
  }
}
